<form class="contact-us-form" [formGroup]="innerForm" (ngSubmit)="submitForm()">
  <h2 class="contact-us-form__header">Get in touch</h2>
  <p class="contact-us-form__sub-header">
    Have a question or know an event we missed? Our friendly team is here to
    help!
  </p>
  <div class="row contact-us-form__inputs">
    <div class="col-12">
      <div class="row">
        <app-input
          class="col-md-6"
          [fc]="innerForm.controls.first_name"
          [label]="'First Name'"
          [placeholder]="'First Name'"
        ></app-input>
        <app-input
          class="col-md-6"
          [fc]="innerForm.controls.last_name"
          [label]="'Last Name'"
          [placeholder]="'Last Name'"
        ></app-input>
      </div>
    </div>

    <div class="col-md-12">
      <app-input
        [fc]="innerForm.controls.email"
        [label]="'Email'"
        type="email"
        [placeholder]="'you@company.com'"
      ></app-input>
    </div>
    <div class="col-md-12">
      <app-select
        [fc]="innerForm.controls.subject"
        [options]="subjectOptions"
        [label]="'Subject'"
      ></app-select>
    </div>
    <div class="col-md-12">
      <app-textarea
        [fc]="innerForm.controls.message"
        [label]="'Message'"
        [rows]="2"
        [placeholder]="'Leave us a message...'"
      ></app-textarea>
    </div>
  </div>

  <re-captcha
    class="d-none"
    size="invisible"
    #recaptcha
    (resolved)="resolveToken($event)"
  ></re-captcha>

  <app-button [submit]="true" [disabled]="innerForm.invalid || disableSubmit">
    Send message
  </app-button>
</form>
